"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  readonly error: Error & { digest?: string };
  readonly reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="mx-auto flex min-h-[60vh] w-full max-w-xl flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="text-2xl font-extrabold text-primary">No pudimos cargar esta sección</h1>
      <p className="text-muted">Intenta nuevamente; tus productos y tu pedido siguen disponibles.</p>
      <button
        className="rounded-lg bg-primary px-5 py-3 font-bold text-white"
        onClick={reset}
        type="button"
      >
        Reintentar
      </button>
    </main>
  );
}
